export default __webpack_public_path__ + "static/media/my_zickle_army_whitepaper_2021-11-03.7b9d090c.pdf";